import { render, staticRenderFns } from "./Badge7.vue?vue&type=template&id=24a29c03&scoped=true"
import script from "./Badge7.vue?vue&type=script&lang=js"
export * from "./Badge7.vue?vue&type=script&lang=js"
import style0 from "./Badge7.vue?vue&type=style&index=0&id=24a29c03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a29c03",
  null
  
)

export default component.exports